/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const planDataTierSchema = z.enum(['lite', 'standard', 'pro', 'premium', 'enterprise', 'service'])

export type PlanDataTierSchema = z.infer<typeof planDataTierSchema>
